import { fontSizes } from '_/config/theme';
import { ExtendedCountryCode, countries } from '_/helpers/countryDials';
import React, { useMemo } from 'react';
import { Image, TouchableOpacity } from 'react-native';

import Text from '../Text';
import { useCountryPickerStore } from '_/store/useCountryPickerStore';

interface CountryPickerProps {
  countryCode?: ExtendedCountryCode;
  onSelect?: (code: ExtendedCountryCode) => void;
}

const CountryPicker: React.FC<CountryPickerProps> = ({ countryCode, onSelect }) => {
  const { openCountryPicker } = useCountryPickerStore();

  const country = useMemo(() => {
    return countries.find((c) => c.code.toLocaleUpperCase() === countryCode);
  }, [countryCode]);

  function handleOpenPicker() {
    openCountryPicker((code) => {
      onSelect?.(code);
    });
  }

  return (
    <TouchableOpacity
      hitSlop={{ top: 12, right: 12, bottom: 12, left: 12 }}
      onPress={handleOpenPicker}
      activeOpacity={1}
      style={{ flexDirection: 'row', alignItems: 'center' }}
    >
      {!!country && (
        <>
          <Image source={country.flag} style={{ width: 30, height: 30, marginRight: 12 }} />
          <Text fontType="semibold" size={fontSizes.lg} style={{ marginRight: 8 }}>
            {country.countryCode}
          </Text>
        </>
      )}
    </TouchableOpacity>
  );
};

export default CountryPicker;
